const sectionId = document.querySelector('.quantity').getAttribute('data-section-id');
const productId = document.querySelector('.quantity').getAttribute('data-product-id');
const checkbox = document.querySelector(".product__custom-option-checkbox");
const charactersInputField = document.querySelector('.characters__input');
const quantityInput = document.querySelector(`#Quantity-${sectionId}-${productId}`);

const subtotal = document.querySelector(".product__subtotal-price-value");
const subtotalDataPrice = subtotal.getAttribute("data-price");
let floatSubtotal = parseFloat(subtotalDataPrice) / 100;

let currentMaterial;
const heightLabel = document.querySelector("[data-option-slug='height']").querySelector(".form__label");
const colorSwatchList = document.querySelector(".product-color-swatch-list");
const colors = Array.from(document.querySelectorAll(".product-color-swatch"));
const selectedColorLabel = document.querySelector(".selected-product-color-swatch-label");

initializeCharacterInput();
initializeMaterialOptions();

function initializeCharacterInput() {
    if (!subtotal) {
        console.warn("Subtotal element not found");
        return;
    }

    if (!checkbox) {
        console.warn("Checkbox not found");
    } else {
        checkbox.addEventListener("change", () => {
            console.log("Checkbox changed", floatSubtotal);
            if (checkbox.checked) {
                characterCount += ADDITIONAL_CHARACTERS;
                updateQuantityAndSubtotal(characterCount, floatSubtotal);
            } else {
                characterCount -= ADDITIONAL_CHARACTERS;
                updateQuantityAndSubtotal(characterCount, floatSubtotal);
            }
        });
    }

    // Add a data attribute to the subtotal element to store the selected variant price. When the quantity is more than 0, update the subtotal with the selected variant price.
    if (quantityInput.value !== "0") {
        subtotal.innerText = floatSubtotal.toFixed(2);
    }

    let characterCount = charactersInputField ? charactersInputField.value.length : 0;
    const ADDITIONAL_CHARACTERS = 2;

    // This event fires whenever a variant product is selected.
    // This event is exposed when a 'Variant selectors' block has been added to
    // a product template or featured product section
    // The selected variant object is passed within the detail object.
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        floatSubtotal = event.data.variant.price / 100;
        updateSubtotalValue(characterCount, floatSubtotal);
    });

    if (charactersInputField && quantityInput) {
        charactersInputField.addEventListener("input", () => {
            characterCount = charactersInputField.value.length;

            if (checkbox) {
                if (checkbox.checked) {
                    characterCount += ADDITIONAL_CHARACTERS;
                    updateQuantityAndSubtotal(characterCount, floatSubtotal);
                }
            }
            updateQuantityAndSubtotal(characterCount, floatSubtotal);
        });
    } else {
        console.error("One or more elements not found in the DOM.");
    }

    function updateQuantityAndSubtotal(characterCount, productPrice) {
        const sanitizedCount = Math.max(0, Math.floor(characterCount));
        quantityInput.value = sanitizedCount;

        updateSubtotalValue(sanitizedCount, productPrice);
    }

    /**
     * Updates the subtotal based on the provided count and price.
     * @param {number} characterCount - The quantity of the product.
     * @param {number} productPrice - The unit price of the product.
     */
    function updateSubtotalValue(characterCount, productPrice) {
        const calculatedSubtotal = characterCount * productPrice;
        const formattedSubtotal = calculatedSubtotal.toFixed(2);
        subtotal.innerText = formattedSubtotal;
    }
}

function initializeMaterialOptions() {
    // Hide some Height values based on materials.
    const initialMaterialSelect = document.querySelector("[name='options[MATERIAL]']");
    // Preprocess colors to create a material-to-colors map
    const materialToColorsMap = createMaterialToColorsMap();
    const heightSelect = document.querySelector("[name='options[HEIGHT]']");
    const heightOptions = Array.from(heightSelect.querySelectorAll("option"));

    if (!heightSelect) {
        console.error("Height select element not found.");
        return;
    }

    if (initialMaterialSelect) {
        currentMaterial = initialMaterialSelect.value;
        updateColors(currentMaterial, materialToColorsMap);

        // Exit the function early if there is no material select element because the color swatches will not change even when a variant changes
    } else if (materialToColorsMap && document.querySelector("[data-product-template]")) {
        currentMaterial = document.querySelector("[data-product-template]").getAttribute("data-product-template");
        currentMaterial = currentMaterial.charAt(0).toUpperCase() + currentMaterial.slice(1);
        updateColors(currentMaterial, materialToColorsMap);
        handleColorChange();
        return;
    } else {
        console.error("MATERIAL select element not found.");
        return;
    }

    if (currentMaterial !== "Sticker") {
        hideStickHeights(heightOptions);
    }

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
        const selectedMaterial = event.data.variant.option1;
        const heightSelect = document.querySelector("[name='options[HEIGHT]']");

        handleMaterialChange(selectedMaterial, materialToColorsMap, heightSelect);
    });

    handleColorChange();
}

function handleColorChange() {
    // Event Delegation for Color Swatches
    colorSwatchList.addEventListener('click', (e) => {
        const color = e.target.closest('.product-color-swatch');
        if (color) {
            const span = color.querySelector('span'); // Assuming the visual element is a span

            // Check if the clicked element is the span
            if (e.target === span) {
                updateSelectedColorLabel(color);

                // Optionally update the hidden input's checked state
                const input = color.querySelector('.product-color-swatch-input');
                if (input) {
                    input.checked = true;
                }
            }
        }
    });
}

function createMaterialToColorsMap() {
    // Preprocess colors to create a material-to-colors map
    const materialToColorsMap = {};

    colors.forEach((color) => {
        const filterValues = color.dataset.filterValue.split(',').map(val => val.trim());
        filterValues.forEach((filter) => {
            // Decode HTML entities if necessary
            const decodedFilter = filter.replace(/&quot;/g, '"');
            if (!materialToColorsMap[decodedFilter]) {
                materialToColorsMap[decodedFilter] = [];
            }
            materialToColorsMap[decodedFilter].push(color);
        });
    });

    return materialToColorsMap;
}

function handleMaterialChange(selectedMaterial, materialToColorsMap, heightSelect) {
    const heightOptions = Array.from(heightSelect.querySelectorAll("option"));
    updateColors(selectedMaterial, materialToColorsMap);

    if ((currentMaterial !== "Sticker" && selectedMaterial === "Sticker") || (currentMaterial === "Sticker" && selectedMaterial === "Sticker")) {
        console.log("All height options are now visible");
    } else if (currentMaterial === "Sticker" && selectedMaterial !== "Sticker") {
        hideStickHeights(heightOptions);
        // selectFirstAvailableHeight(heightOptions);
    } else {
        hideStickHeights(heightOptions);
    }
    currentMaterial = selectedMaterial;
}

// Function to update colors based on selected material
function updateColors(material, materialToColorsMap) {
    // Convert associated colors array to a Set for efficient lookup
    const associatedColors = new Set(materialToColorsMap[material] || []);
    // Remove the checked attribute from all color input fields
    colors.forEach(color => {
        const input = color.querySelector('.product-color-swatch-input');

        if (associatedColors.has(color)) {
            color.classList.remove('hidden');
        } else {
            color.classList.add('hidden');

            if (input) {
                input.checked = false; // Uncheck if it's being hidden
            }
        }

        // Remove checked attribute from all color input fields
        // input.checked = false and input.removeAttribute("checked", "") are both needed to ensure the input is unchecked 
        //to ensure consistency between the JavaScript state and the HTML attributes
        if (input) {
            input.checked = false; // Set the checked state to false
            input.removeAttribute("checked"); // Remove the checked attribute
        } else {
            console.error("No input found for color swatch");
        }
    });

    // Add the checked attribute to the first visible color element
    const firstVisibleColor = colors.find(color => !color.classList.contains('hidden'));
    if (firstVisibleColor) {
        const input = firstVisibleColor.querySelector('.product-color-swatch-input');

        if (input) {
            input.checked = true;
            input.setAttribute("checked", ""); // Add the checked attribute
            updateSelectedColorLabel(firstVisibleColor);
        }
    } else {
        console.error("No visible color found for material: ", material);
    }
}

function updateSelectedColorLabel(color) {
    const input = color.querySelector('.product-color-swatch-input');
    selectedColorLabel.innerText = input.value;
}

function hideStickHeights(heightOptions) {
    heightOptions.forEach((option) => {
        if (!option) {
            console.error("Height option not found.");
            return;
        }

        if (option.value.includes("sticker")) {
            option.hidden = true;
            option.disabled = true;
        } else {
            option.hidden = false;
            option.disabled = false;
        }
    });
}

// function selectFirstAvailableHeight(heightOptions) {
//     const firstVisibleHeight = heightOptions.find(option => !option.hidden);
//     if (firstVisibleHeight) {
//         firstVisibleHeight.selected = true;
//     } else {
//         heightOptions.forEach(option => {
//             option.selected = false;
//         });
//     }
// }
